import { render, staticRenderFns } from "./TicketClientListTable.vue?vue&type=template&id=02b53ccc&scoped=true"
import script from "./TicketClientListTable.vue?vue&type=script&lang=js"
export * from "./TicketClientListTable.vue?vue&type=script&lang=js"
import style0 from "./TicketClientListTable.vue?vue&type=style&index=0&id=02b53ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b53ccc",
  null
  
)

export default component.exports